
export enum FoodPoisonCd {
	FOOD = 'Food',
	NEITHER = 'Neither',
	POISON = 'Poison'}

